/** CSV для Excel (русская локаль): `;`, UTF-8 BOM, CRLF. */

export const EXCEL_CSV_SEP = ";";

export function escapeExcelCsvCell(value) {
  return `"${String(value ?? "").replace(/"/g, '""')}"`;
}

export function buildExcelCsv(headers, rows) {
  const lines = [
    (headers || []).map(escapeExcelCsvCell).join(EXCEL_CSV_SEP),
    ...(rows || []).map((row) =>
      (row || []).map(escapeExcelCsvCell).join(EXCEL_CSV_SEP),
    ),
  ];
  return `\uFEFF${lines.join("\r\n")}`;
}

export function formatCsvNumber(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return "";
  return String(v).replace(".", ",");
}

export function formatCsvDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    const s = String(iso);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    return s.slice(0, 10);
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}.${m}.${y}`;
}

export function downloadExcelCsv(filename, headers, rows) {
  const csv =
    typeof headers === "string" ? headers : buildExcelCsv(headers, rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  downloadBlobFile(blob, filename);
}

export function downloadBlobFile(data, filename, mime = "text/csv;charset=utf-8") {
  const blob =
    data instanceof Blob ? data : new Blob([data], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function parseExcelCsvLine(line, delimiter = EXCEL_CSV_SEP) {
  const out = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          cur += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        cur += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === delimiter) {
      out.push(cur);
      cur = "";
    } else {
      cur += ch;
    }
  }
  out.push(cur);
  return out;
}

function countUnquoted(line, ch) {
  let n = 0;
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const c = line[i];
    if (c === '"') {
      if (inQuotes && line[i + 1] === '"') {
        i += 1;
        continue;
      }
      inQuotes = !inQuotes;
    } else if (!inQuotes && c === ch) {
      n += 1;
    }
  }
  return n;
}

export function detectExcelCsvDelimiter(headerLine) {
  const semi = countUnquoted(headerLine, ";");
  const comma = countUnquoted(headerLine, ",");
  return semi > comma ? ";" : ",";
}

export function parseExcelCsv(text) {
  const lines = String(text || "")
    .replace(/^\uFEFF/, "")
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l && !/^sep\s*=/i.test(l));
  if (!lines.length) return { headers: [], rows: [] };
  const delimiter = detectExcelCsvDelimiter(lines[0]);
  const headers = parseExcelCsvLine(lines[0], delimiter).map((h) =>
    h.trim().toLowerCase().replace(/\s+/g, "_"),
  );
  const rows = lines.slice(1).map((line) =>
    parseExcelCsvLine(line, delimiter).map((c) => c.trim()),
  );
  return { headers, rows };
}
